import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  display: inline-block;
  max-width: 40ch;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ScrollableSpan: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const spanRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const span = spanRef.current;
    if (!span) return;

    const handleWheel = (e: WheelEvent) => {
      if (e.deltaY === 0) return;
      e.preventDefault();
      span.scrollLeft += e.deltaY;
    };

    span.addEventListener('wheel', handleWheel, { passive: false });
    return () => span.removeEventListener('wheel', handleWheel);
  }, []);

  return <StyledSpan ref={spanRef}>{children}</StyledSpan>;
};

export default ScrollableSpan;
